import React, { createContext, useContext, useEffect, useState } from "react";
import { nodeSocket } from "./nodeSocket";

const NodeSocketContext = createContext();

export const NodeSocketProvider = ({ children }) => {
  const [messages, setMessages] = useState([]);
  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    // Connection event handlers
    nodeSocket.on("connect", () => {
      setIsConnected(true);

      // Get vendor_type from localStorage
      const vendorType = (localStorage.getItem("vendor_type") || "")
        .replace(/"/g, "")
        .trim()
        .toLowerCase();

      // Subscribe to the correct channel with vendor_type
      const channel = vendorType ? `in_progress.${vendorType}` : "in_progress";
      nodeSocket.emit("subscribe", channel);
    });

    nodeSocket.on("disconnect", () => {
      setIsConnected(false);
    });

    nodeSocket.on("connect_error", (error) => {
      console.error("🚨 Connection error:", error);
    });

    // MAIN EVENT LISTENER
    nodeSocket.on("event_from_odoo", (msg) => {
      setMessages((prev) => [...prev, msg]);
    });

    // Connect the socket
    nodeSocket.connect();

    return () => {
      nodeSocket.off("connect");
      nodeSocket.off("disconnect");
      nodeSocket.off("connect_error");
      nodeSocket.off("event_from_odoo");
      nodeSocket.offAny();
      nodeSocket.disconnect();
    };
  }, []);

  return (
    <NodeSocketContext.Provider value={{ socket: nodeSocket, messages, isConnected }}>
      {children}
    </NodeSocketContext.Provider>
  );
};

export const useNodeSocket = () => useContext(NodeSocketContext);